module.exports = __webpack_public_path__ + "static/media/START.65538be4.png";